<h1 class="mf-popup-title overflow-hidden text-nowrap">Urejanje stranke</h1>
<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content">
            <cust-customer-details
                #customerDetails
                [customerForEdit]="customer"
                [isNewCustomer]="newCustomer"
                (saveCustomer)="saveCustomer(true)"
            ></cust-customer-details>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="cancelCustomerEdit()" type="button" style="min-width: 150px" class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom">
        Prekliči
    </button>
    <button (click)="saveCustomer(false)" type="button" style="min-width: 150px" class="mr-auto btn m-btn--pill btn-accent m-btn">Potrdi</button>
</div>
